export const nameAndDevicePattern = /^([a-zA-Z0-9.@_ -]+)?$/;
